// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"wm_a bib_b bib_we"};